// Mapping table cho YouTube links thực tế
export const youtubeLinksMap: Record<string, string> = {
  // Lớp 10
  '10-0-1': 'https://www.youtube.com/watch?v=FsuFFM2-5oE', // Bài 1: Giới thiệu mục đích học tập môn Vật lí
  '10-1-2': 'https://www.youtube.com/watch?v=3gKlpB1YqYs', // Bài 2: Độ dịch chuyển và Quãng đường đi được
  '10-1-3': 'https://www.youtube.com/watch?v=_2fBwowRdg8', // Bài 3: Tốc độ và Vận tốc
  '10-1-4': 'https://www.youtube.com/watch?v=P18-j5v9VHc',
  '10-1-5': 'https://www.youtube.com/watch?v=RWYLt9hbM0o',
  '10-1-6': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_6',
  '10-1-7': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_7',
  '10-2-8': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_8',
  '10-2-9': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_9',
  '10-2-10': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_10',
  '10-2-11': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_11',
  '10-2-12': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_12',
  '10-3-13': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_13',
  '10-3-14': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_14',
  '10-3-15': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_15',
  '10-3-16': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_16',
  '10-3-17': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_17',
  '10-4-18': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_18',
  '10-4-19': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_19',
  '10-4-20': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_20',

  // Lớp 11
  '11-1-1': 'https://www.youtube.com/watch?v=85xSnshdTZs',
  '11-1-2': 'https://www.youtube.com/watch?v=YMoy-diPUEg', // Thay thế bằng link YouTube thực cho bài 2
  '11-1-3': 'https://www.youtube.com/watch?v=lYvNS4Dmt2c',
  '11-1-4': 'https://www.youtube.com/watch?v=_rnCDGcNpaE',
  '11-2-5': 'https://www.youtube.com/watch?v=4WePU7tnkhk',
  '11-2-6': 'https://www.youtube.com/watch?v=m842m3XMwG4', // Bài 6: Sóng dọc và sóng ngang
  '11-2-7': 'https://www.youtube.com/watch?v=rQw7BjTMXKk', // Bài 7: Sóng điện từ
  '11-2-8': 'https://www.youtube.com/watch?v=Ttt6IxC3eS0',// Bài 8: Giao thoa sóng
  '11-2-9': 'https://www.youtube.com/watch?v=AuCEh4EI34I',//Bài 9: Sóng dừng
  '11-2-10': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_30',
  '11-3-11': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_31',
  '11-3-12': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_32',
  '11-3-13': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_33',
  '11-3-14': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_34',
  '11-4-15': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_35',
  '11-4-16': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_36',
  '11-4-17': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_37',
  '11-4-18': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_38',

  // Lớp 12
  '12-1-1': 'https://www.youtube.com/watch?v=Rc4aEUANVdU',
  '12-1-2': 'https://www.youtube.com/watch?v=7OrUGtxMx-E',
  '12-1-3': 'https://www.youtube.com/watch?v=XmN-3uCzeg8',
  '12-1-4': 'https://www.youtube.com/watch?v=IFlgNkWjcLo',
  '12-1-5': 'https://www.youtube.com/watch?v=aSgZeUeEbT8&t', // Đã thay bằng link thực tế
  '12-1-6': 'https://www.youtube.com/watch?v=GDy7ckf4yQE',
  '12-2-7': 'https://www.youtube.com/watch?v=30gwgIUZYko',
  '12-2-8': 'https://www.youtube.com/watch?v=rMoigzjPVu0',
  '12-2-9': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_47',
  '12-2-10': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_48',
  '12-2-11': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_49',
  '12-3-12': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_50',
  '12-3-13': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_51',
  '12-3-14': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_52',
  '12-3-15': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_53',
  '12-3-16': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_54',
  '12-3-17': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_55',
  '12-4-18': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_56',
  '12-4-19': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_57',
  '12-4-20': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_58',
  '12-4-21': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_59',
  '12-4-22': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_60',
  '12-4-23': 'https://www.youtube.com/watch?v=YOUR_VIDEO_ID_61',
}

// Hàm lấy YouTube URL từ mapping
export const getYouTubeUrl = (lop: string, chuong: string, bai: string): string | null => {
  const key = `${lop}-${chuong}-${bai}`
  console.log('🔍 getYouTubeUrl Debug:', { lop, chuong, bai, key, found: !!youtubeLinksMap[key] })
  return youtubeLinksMap[key] || null
}
